import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import dayjs from 'dayjs';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Form from '@afosto/app-components-react/Form';
import TextField from '@afosto/app-components-react/TextField';
import Checkbox from '@afosto/app-components-react/Checkbox';
import DateTimePicker from '@afosto/app-components-react/DateTimePicker';
import translations from './translations';
import validationSchema from './validations';
import Button from '@material-ui/core/Button';
import uuid from '@afosto/utils/uuid';
import { FormattedMessage } from 'react-intl';

const currentDate = dayjs();

const CouponCodeForm = ({ inline, isEditing, code, category, onSubmit, onCancel, readOnly }) => {
  const intl = useIntl();

  const expiresAtDefaultValue = currentDate.add(category?.defaults?.expires_after, 'seconds');

  const form = useForm({
    validationSchema,
    editInline: inline,
    defaultValues: {
      code: code?.code ?? '',
      expiresAt: code?.expiresAt ?? (!readOnly ? expiresAtDefaultValue : null),
      isUnlimited: code?.usage?.isUnlimited ?? category?.defaults?.usage?.is_unlimited,
      remaining: code?.usage?.remaining ?? category?.defaults?.usage?.limit,
    },
    isEditing,
    onSubmit,
    onCancel,
  });
  const { watch, setValue } = form;
  const isUnlimitedValue = watch('isUnlimited');

  const handleGenerateRandomCode = () => {
    setValue('code', uuid());
  };

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <TextField
          name="code"
          label={intl.formatMessage(translations.fields.code.label)}
          readOnly={readOnly}
          InputProps={{
            endAdornment: (
              <Button color="primary" size="small" onClick={handleGenerateRandomCode}>
                <FormattedMessage {...translations.fields.code.random} />
              </Button>
            ),
          }}
        />
        <DateTimePicker
          name="expiresAt"
          label={intl.formatMessage(translations.fields.expiresAt.label)}
          readOnly={readOnly}
          disableFuture={false}
          disablePast
        />
        <Checkbox
          name="isUnlimited"
          label={intl.formatMessage(translations.fields.isUnlimited.label)}
          readOnly={readOnly}
        />
        {!isUnlimitedValue && (
          <TextField
            name="remaining"
            label={intl.formatMessage(translations.fields.remaining.label)}
            readOnly={readOnly}
            type="number"
          />
        )}
      </Form>
    </LoadingWrapper>
  );
};

CouponCodeForm.propTypes = {
  category: PropTypes.object,
  code: PropTypes.object,
  inline: PropTypes.bool,
  isEditing: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  readOnly: PropTypes.bool,
};

CouponCodeForm.defaultProps = {
  category: undefined,
  code: undefined,
  inline: true,
  isEditing: false,
  onCancel: undefined,
  onSubmit: undefined,
  readOnly: false,
};

export default CouponCodeForm;
